module.exports = __webpack_public_path__ + "img/symbol_3.7d86781b.png";